export const AdmissionReleaseModeFr: { [key: string]: string } = {
  0: '0 - Transfert inter-établissement',
  6: '6 - Mutation',
  7: '7 - Transfert entre entités juridiques',
  8: '8 - Domicile',
}

export const AdmissionModeFrMco = {
  N: 'N - Naissance',
  O: 'O - Patient entré décédé pour prélèvement d\'organes',
}

export const AdmissionModeFr: { [key: string]: string } = {
  ...AdmissionReleaseModeFr,
  ...AdmissionModeFrMco
}

export const ReleaseModeFr: { [key: string]: string } = {
  ...AdmissionReleaseModeFr,
  9: '9 - Décès',
}

const AdmissionReleaseModeCh: { [key: string]: string } = {
  4: '04 - Transfert interne',
  8: '08 - Autre',
  9: '09 - Inconnu',
}

export const AdmissionModeCh: { [key: string]: string } = {
  ...AdmissionReleaseModeCh,
  1: '01 - Urgence (nécessité d’un traitement dans les 12 heures)',
  2: '02 - Annoncé, planifié',
  3: '03 - Naissance (enfant né intra-muros)',
  5: '05 - Transfert dans les 24 heures',
}

export const ReleaseModeCh: { [key: string]: string } = {
  ...AdmissionReleaseModeCh,
  1: '01 - Sur l\'initiative du traitant',
  2: '02 - Sur l\'initiative du patient (contre l\'avis du traitant)',
  3: '03 - Sur l\'initiative d\'une tierce personne',
  5: '05 - Décès',
}
